/**
 * Product Discount Display Component
 * 
 * This custom element listens for variant change events and updates
 * the discount percentage display dynamically on product pages.
 */

class ProductDiscountDisplay extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.boundHandleVariantChange = this.handleVariantChange.bind(this);
  }

  connectedCallback() {
    // Listen for variant change events from variant picker
    document.addEventListener('variant:change', this.boundHandleVariantChange);
    
    // Also listen for the product-price update event if it exists
    document.addEventListener('product-price:update', this.boundHandleVariantChange);
  }

  disconnectedCallback() {
    document.removeEventListener('variant:change', this.boundHandleVariantChange);
    document.removeEventListener('product-price:update', this.boundHandleVariantChange);
  }

  /**
   * Handle variant change events
   * @param {CustomEvent} event - The variant change event
   */
  handleVariantChange(event) {
    const variant = event.detail?.variant;
    
    if (!variant) return;

    // Calculate discount percentage
    const compareAtPrice = variant.compare_at_price;
    const price = variant.price;
    
    if (compareAtPrice && compareAtPrice > price) {
      const discount = compareAtPrice - price;
      const discountPercentage = Math.round((discount / compareAtPrice) * 100);
      
      // Update the display
      this.updateDisplay(discountPercentage);
    } else {
      // No discount, hide the badge
      this.updateDisplay(0);
    }
  }

  /**
   * Update the discount badge display
   * @param {number} percentage - The discount percentage to display
   */
  updateDisplay(percentage) {
    if (percentage > 0) {
      this.innerHTML = `<span class="discount-badge">${percentage}% OFF</span>`;
    } else {
      this.innerHTML = '';
    }
  }
}

// Register the custom element
if (!customElements.get('product-discount-display')) {
  customElements.define('product-discount-display', ProductDiscountDisplay);
}
